module.exports = __webpack_public_path__ + "img/poids.svg";